import { render, staticRenderFns } from "./55modelImageMaterial.vue?vue&type=template&id=0f84b8f3&scoped=true&"
import script from "./55modelImageMaterial.vue?vue&type=script&lang=js&"
export * from "./55modelImageMaterial.vue?vue&type=script&lang=js&"
import style0 from "./55modelImageMaterial.vue?vue&type=style&index=0&id=0f84b8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84b8f3",
  null
  
)

export default component.exports